<template>
  <div id="pages-authentication-code">
    <div id="pages-authentication-code__container">
      <div id="pages-authentication-code__title">
        {{ $t('authenticationCode.base.title') }}
      </div>
      <div id="pages-authentication-code__description">
        {{ $t('authenticationCode.base.description') }}
      </div>
      <div id="pages-authentication-code__tip">
        {{ $t('authenticationCode.base.tip') }}
      </div>
      <AuthenticationCodeForm
        :onLogin="login"
        :contactInfo="contactInfo"
      />
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'
import { mapActions, mapMutations } from 'vuex'

import AuthenticationCodeForm from '@/modules/authenticationCodeForm/AuthenticationCodeForm'
import { login2FA } from '@/api/auth/request'
import { UserType } from '@/utils/consts'
import { resetForm } from '@/store/util'
import notification from '@/utils/notification'
import usePublicLogin from '@/pages/usePublicLogin'
import types from '@/store/mutation-types'
import { getExtHomePageByUserDomain } from './utils'

export default {
  name: 'AuthenticationCode',
  components: { AuthenticationCodeForm },
  setup () {
    const { toNextPage } = usePublicLogin()
    return { toNextPage }
  },
  data () {
    return {
      receivedParams: null,
      portalTypes: {
        contractor: 'vendorHome',
        tenant: 'tenantDashboard',
      },
    }
  },
  computed: {
    contactInfo () {
      let result
      if (lodash.isNull(this.receivedParams)) {
        result = null
      } else {
        const sms = lodash.get(this.receivedParams, ['profile_phone_number'])
        const id = lodash.get(this.receivedParams, ['id'])
        const username = lodash.get(this.receivedParams, ['username'])
        const email = this.receivedParams.profile_email || this.receivedParams.email || username

        result = { email, sms, id }
      }
      return result
    },
  },
  mounted () {
    const params = this.$router.currentRoute.params
    if (lodash.isEmpty(params)) {
      this.$router.replace({ name: '/pub/login' })
    } else {
      this.receivedParams = params
    }
  },
  methods: {
    async login (code) {
      const homePage = getExtHomePageByUserDomain(this.receivedParams.activePortal)
      try {
        resetForm()
        const id = lodash.get(this.contactInfo, ['id'])
        const response = await login2FA(id, code)
        this.setJwt(response.headers.authorization)
        const user = response.data.data.user
        await this.postLoginAction({ user })
        await this.switchLang()
        await this.loadContact({ accountId: user.accountId, userId: user.id, externalId: user.externalId })
        await this.loadPerms({ perms: this.enhancePerms(response.data.data.acl, user) })
        this.toNextPage(homePage, (path) => {
          path.startsWith('/vendors') || path.startsWith('/tenants')
        })
      } catch (err) {
        notification.handleResponseError(err, 'authenticationCode')
      }
    },
    findSubVendorRole (user) {
      return lodash.get(user, 'roles', []).find(role => role.usertype === UserType.Vendor.User)
    },
    enhancePerms (acl, user) {
      const subVendor = this.findSubVendorRole(user)
      if (subVendor) {
        acl[subVendor.id] = user.perms
      }
      return acl
    },
    ...mapActions('access', {
      loadPerms: 'loadPerms',
    }),
    ...mapActions('user', {
      loadContact: 'loadContact',
    }),
    ...mapActions('user', [
      'postLoginAction',
    ]),
    ...mapActions('language', ['switchLang']),
    ...mapMutations('settings', {
      setJwt: types.JSON_WEB_TOKEN,
    }),
  },
}
</script>

<style lang='scss' scoped>
  @mixin textStyle {
    line-height: 2;
  }

  @mixin textField {
    width: 90%;
  }

  #pages-authentication-code {
    width: 100%;
    height: 100%;
    background-color: #ebebeb;
    position: relative;
  }

  #pages-authentication-code__container {
    width: 700px;
    margin: 0 auto;
    padding-top: 5%;

    #pages-authentication-code__title {
      font-weight: 700;
      font-size: 18px;
      @include textStyle;
    }

    #pages-authentication-code__description {
      @include textStyle;
      @include textField;
    }

    #pages-authentication-code__tip {
      @include textStyle;
      @include textField;
      margin: 18px 0;
    }
  }
</style>
